import React, { useState, useEffect } from "react";
import { Form, Button, DatePicker, Input, Radio, TimePicker, Row, Col, Select } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import SisLoader from "../../../widgets/loader";
import { ErrorToast, SuccessToast } from "../../../widgets/AppToast";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import { robOptions } from "../../../Data/data";

const { Option } = Select;

function AddStaffVoyage() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loader, set_loader] = useState(false);
  const [loadPorts, set_loadPorts] = useState([
    { port_name: "", arrival_draft: "", eta: "", departure_draft: "", etd: "" },
  ]);
  const [dischargePorts, set_dischargePorts] = useState([
    { port_name: "", arrival_draft: "", eta: "", departure_draft: "", etd: "" },
  ]);
  const [fuelData, setFuelData] = useState([
    { fuelType: null, Initialiy_rob: "", Initial_rob: "" },
  ]);

  const GET_STAFF_DASHBOARD_DETAILS = async () => {
    try {
      const FORM_DATA = new FormData();
      const res = await post(ApiURL.staff_dashboard, FORM_DATA);
      if (res?.status === true) {
        const dashboardData = res?.data || null;
        localStorage.setItem("staff_dashboard", JSON.stringify(dashboardData));
      } else {
        console.error("Error: Response status is false.");
        localStorage.setItem("staff_dashboard", JSON.stringify(null));
      }
    } catch (error) {
      console.error("Error fetching Staff Dashboard data:", error);
      localStorage.setItem("staff_dashboard", JSON.stringify(null));
    }
  };

  const handleAddLoadPort = () => {
    set_loadPorts([
      ...loadPorts,
      { port_name: "", arrival_draft: "", eta: "", departure_draft: "", etd: "" },
    ]);
  };

  const handleAddDischargePort = () => {
    set_dischargePorts([
      ...dischargePorts,
      { port_name: "", arrival_draft: "", eta: "", departure_draft: "", etd: "" },
    ]);
  };

  const handleAddFuelType = () => {
    setFuelData([...fuelData, { fuelType: null, Initialiy_rob: "", Initial_rob: "" }]);
  };

  const handleRemoveLoadPort = (index) => {
    if (loadPorts.length > 1) {
      set_loadPorts(loadPorts.filter((_, i) => i !== index));
    }
  };

  const handleRemoveDischargePort = (index) => {
    if (dischargePorts.length > 1) {
      set_dischargePorts(dischargePorts.filter((_, i) => i !== index));
    }
  };

  const handleRemoveFuelType = (index) => {
    if (fuelData.length > 1) {
      setFuelData(fuelData.filter((_, i) => i !== index));
    }
  };

  const handleFuelChange = (index, key, value) => {
    const updatedFuelData = [...fuelData];
    updatedFuelData[index][key] = value;
    setFuelData(updatedFuelData);
  };

  // Prevents typing the minus sign in numeric inputs
  const preventNegativeInput = (e) => {
    if (e.key === "-" || e.key === "e" || e.key === "E" || e.key === "+") {
      e.preventDefault();
    }
  };

  // Sanitises a numeric string to ensure it is non-negative
  const sanitizePositive = (val) => {
    if (val === "" || val === null || val === undefined) return val;
    const num = parseFloat(val);
    if (!isNaN(num) && num < 0) return "0";
    return val;
  };

  const onFinish = async (values) => {
    set_loader(true);
    try {
      const formattedValues = {
        ...values,
        voyage_date: values.voyage_date ? values.voyage_date.format("YYYY-MM-DD") : "",
        voyage_time: values.voyage_time ? values.voyage_time.format("HH:mm:ss") : "",
        load_ports: loadPorts.map((port) => ({
          ...port,
          eta: port.eta ? dayjs(port.eta).format("YYYY-MM-DD HH:mm:ss") : "",
          etd: port.etd ? dayjs(port.etd).format("YYYY-MM-DD HH:mm:ss") : "",
        })),
        discharge_ports: dischargePorts.map((port) => ({
          ...port,
          eta: port.eta ? dayjs(port.eta).format("YYYY-MM-DD HH:mm:ss") : "",
          etd: port.etd ? dayjs(port.etd).format("YYYY-MM-DD HH:mm:ss") : "",
        })),
        rob_fuel: fuelData
          .filter((fuel) => fuel.fuelType && fuel.Initialiy_rob)
          .map((fuel) => ({
            fuelType: fuel.fuelType,
            Initialiy_rob: fuel.Initialiy_rob,
            Initial_rob: fuel.Initialiy_rob,
          })),
      };

      const FORM_DATA = new FormData();
      FORM_DATA.append("voyage_type", formattedValues.voyage_type || "laden");
      FORM_DATA.append("voyage_time", formattedValues.voyage_time || "");
      FORM_DATA.append("voyage_date", formattedValues.voyage_date || "");
      FORM_DATA.append("voyage_no", formattedValues.voyage_no || "");
      FORM_DATA.append("load_ports", JSON.stringify(formattedValues.load_ports));
      FORM_DATA.append("discharge_ports", JSON.stringify(formattedValues.discharge_ports));
      FORM_DATA.append("charterer_speed", formattedValues.charterer_speed || "");
      FORM_DATA.append("fuel_consumption", formattedValues.fuel_consumption || "");
      FORM_DATA.append("rob_fuel", JSON.stringify(formattedValues.rob_fuel));

      const res = await post(ApiURL.add_voyage_info, FORM_DATA);
      if (res?.status === true) {
        SuccessToast("Success", res?.message || "Voyage added successfully!");
        await GET_STAFF_DASHBOARD_DETAILS();
        navigate("/staff-voyage-list");
      } else {
        ErrorToast(
          "Voyage Error",
          res?.error ||
            "Sorry, first you have to complete the running voyage before creating a new one for this ship."
        );
      }
    } catch (error) {
      console.error("Error adding voyage:", error);
      ErrorToast("Error", "An unexpected error occurred. Please try again later.");
    } finally {
      set_loader(false);
    }
  };

  return (
    <div className="white-container">
      <h3>Add Voyage</h3>
      <br />
      {loader ? (
        <SisLoader />
      ) : (
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item
                name="voyage_no"
                label="Voyage Number"
                rules={[{ required: true, message: "Please enter the voyage number" }]}
              >
                <Input placeholder="Enter Voyage Number" />
              </Form.Item>
            </Col>
          
          </Row>

          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item
                name="voyage_time"
                label="Time"
                rules={[{ required: true, message: "Please select the time" }]}
              >
                <TimePicker
                  style={{ width: "100%" }}
                  format="HH:mm:ss"
                  defaultOpenValue={dayjs("00:00:00", "HH:mm:ss")}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="voyage_date"
                label="Date"
                rules={[{ required: true, message: "Please select the date" }]}
              >
                <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <Form.Item
                name="voyage_type"
                label="Voyage Type"
                initialValue="laden"
                rules={[{ required: true, message: "Please select the voyage type" }]}
              >
                <Radio.Group>
                  <Radio value="laden">Laden</Radio>
                  <Radio value="ballast">Ballast</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>

          {/* Load Ports Section */}
          <div className="margin-top">
            <h4>Load Port(s)</h4>
            {loadPorts.map((port, index) => (
              <div key={index} style={{ marginBottom: 16 }}>
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <label className="block-label">Port Name</label>
                      {loadPorts.length > 1 && (
                        <CloseCircleOutlined
                          style={{ color: "red", cursor: "pointer", fontSize: "16px" }}
                          onClick={() => handleRemoveLoadPort(index)}
                        />
                      )}
                    </div>
                    <Input
                      value={port.port_name}
                      onChange={(e) =>
                        set_loadPorts((prev) => {
                          const updated = [...prev];
                          updated[index].port_name = e.target.value;
                          return updated;
                        })
                      }
                      placeholder="Enter Port Name"
                    />
                  </Col>
                </Row>
                <Row gutter={[16, 16]} style={{ marginTop: 8 }}>
                  <Col span={6}>
                    <label className="block-label">Arrival Draft</label>
                    <Input
                      value={port.arrival_draft}
                      onChange={(e) =>
                        set_loadPorts((prev) => {
                          const updated = [...prev];
                          updated[index].arrival_draft = sanitizePositive(e.target.value);
                          return updated;
                        })
                      }
                      placeholder="Arrival Draft"
                      type="number"
                      min={0}
                      onKeyDown={preventNegativeInput}
                    />
                  </Col>
                  <Col span={6}>
                    <label className="block-label">ETA</label>
                    <DatePicker
                      showTime
                      format="YYYY-MM-DD HH:mm:ss"
                      style={{ width: "100%" }}
                      onChange={(date, dateString) =>
                        set_loadPorts((prev) => {
                          const updated = [...prev];
                          updated[index].eta = dateString;
                          return updated;
                        })
                      }
                    />
                  </Col>
                  <Col span={6}>
                    <label className="block-label">Departure Draft</label>
                    <Input
                      value={port.departure_draft}
                      onChange={(e) =>
                        set_loadPorts((prev) => {
                          const updated = [...prev];
                          updated[index].departure_draft = sanitizePositive(e.target.value);
                          return updated;
                        })
                      }
                      placeholder="Departure Draft"
                      type="number"
                      min={0}
                      onKeyDown={preventNegativeInput}
                    />
                  </Col>
                  <Col span={6}>
                    <label className="block-label">ETD</label>
                    <DatePicker
                      showTime
                      format="YYYY-MM-DD HH:mm:ss"
                      style={{ width: "100%" }}
                      onChange={(date, dateString) =>
                        set_loadPorts((prev) => {
                          const updated = [...prev];
                          updated[index].etd = dateString;
                          return updated;
                        })
                      }
                    />
                  </Col>
                </Row>
              </div>
            ))}
            <Button type="dashed" onClick={handleAddLoadPort} style={{ marginTop: 8 }}>
              + Add Another Load Port
            </Button>
          </div>

          {/* Discharge Ports Section */}
          <div className="margin-top">
            <h4>Discharge Port(s)</h4>
            {dischargePorts.map((port, index) => (
              <div key={index} style={{ marginBottom: 16 }}>
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <label className="block-label">Port Name</label>
                      {dischargePorts.length > 1 && (
                        <CloseCircleOutlined
                          style={{ color: "red", cursor: "pointer", fontSize: "16px" }}
                          onClick={() => handleRemoveDischargePort(index)}
                        />
                      )}
                    </div>
                    <Input
                      value={port.port_name}
                      onChange={(e) =>
                        set_dischargePorts((prev) => {
                          const updated = [...prev];
                          updated[index].port_name = e.target.value;
                          return updated;
                        })
                      }
                      placeholder="Enter Port Name"
                    />
                  </Col>
                </Row>
                <Row gutter={[16, 16]} style={{ marginTop: 8 }}>
                  <Col span={6}>
                    <label className="block-label">Arrival Draft</label>
                    <Input
                      value={port.arrival_draft}
                      onChange={(e) =>
                        set_dischargePorts((prev) => {
                          const updated = [...prev];
                          updated[index].arrival_draft = sanitizePositive(e.target.value);
                          return updated;
                        })
                      }
                      placeholder="Arrival Draft"
                      type="number"
                      min={0}
                      onKeyDown={preventNegativeInput}
                    />
                  </Col>
                  <Col span={6}>
                    <label className="block-label">ETA</label>
                    <DatePicker
                      showTime
                      format="YYYY-MM-DD HH:mm:ss"
                      style={{ width: "100%" }}
                      onChange={(date, dateString) =>
                        set_dischargePorts((prev) => {
                          const updated = [...prev];
                          updated[index].eta = dateString;
                          return updated;
                        })
                      }
                    />
                  </Col>
                  <Col span={6}>
                    <label className="block-label">Departure Draft</label>
                    <Input
                      value={port.departure_draft}
                      onChange={(e) =>
                        set_dischargePorts((prev) => {
                          const updated = [...prev];
                          updated[index].departure_draft = sanitizePositive(e.target.value);
                          return updated;
                        })
                      }
                      placeholder="Departure Draft"
                      type="number"
                      min={0}
                      onKeyDown={preventNegativeInput}
                    />
                  </Col>
                  <Col span={6}>
                    <label className="block-label">ETD</label>
                    <DatePicker
                      showTime
                      format="YYYY-MM-DD HH:mm:ss"
                      style={{ width: "100%" }}
                      onChange={(date, dateString) =>
                        set_dischargePorts((prev) => {
                          const updated = [...prev];
                          updated[index].etd = dateString;
                          return updated;
                        })
                      }
                    />
                  </Col>
                </Row>
              </div>
            ))}
            <Button type="dashed" onClick={handleAddDischargePort} style={{ marginTop: 8 }}>
              + Add Another Discharge Port
            </Button>
          </div>

          {/* Charterer Details */}
          <Row gutter={[16, 16]} className="margin-top">
            <Col span={12}>
              <Form.Item
                name="charterer_speed"
                label="Instructed Charterer's Speed"
                rules={[
                  {
                    validator: (_, value) =>
                      value === undefined || value === "" || parseFloat(value) >= 0
                        ? Promise.resolve()
                        : Promise.reject(new Error("Speed must be a positive value")),
                  },
                ]}
              >
                <Input
                  placeholder="Enter Charterer's Speed"
                  type="number"
                  min={0}
                  onKeyDown={preventNegativeInput}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="fuel_consumption"
                label="Instructed Charterer's Fuel Consumption"
                rules={[
                  {
                    validator: (_, value) =>
                      value === undefined || value === "" || parseFloat(value) >= 0
                        ? Promise.resolve()
                        : Promise.reject(new Error("Fuel consumption must be a positive value")),
                  },
                ]}
              >
                <Input
                  placeholder="Enter Fuel Consumption"
                  type="number"
                  min={0}
                  onKeyDown={preventNegativeInput}
                />
              </Form.Item>
            </Col>
          </Row>

          {/* Fuel Types Section */}
          <div className="margin-top">
            <h4>Fuel / Lub Types and Initial ROB</h4>
            {fuelData.map((item, index) => (
              <div key={index} style={{ marginBottom: 16 }}>
                <Row gutter={[16, 16]}>
                  <Col span={12}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <label className="block-label">Select Fuel / Lub Type</label>
                      {fuelData.length > 1 && (
                        <CloseCircleOutlined
                          style={{ color: "red", cursor: "pointer", fontSize: "16px" }}
                          onClick={() => handleRemoveFuelType(index)}
                        />
                      )}
                    </div>
                    <Select
                      placeholder="-- Select Fuel Type --"
                      style={{ width: "100%" }}
                      value={item.fuelType}
                      onChange={(value) => handleFuelChange(index, "fuelType", value)}
                      allowClear
                    >
                      {Array.isArray(robOptions) &&
                        robOptions.map((fuel, i) => (
                          <Option key={i} value={fuel.value}>
                            {fuel.label}
                          </Option>
                        ))}
                    </Select>
                  </Col>
                  <Col span={12}>
                    <label className="block-label">Initial ROB ({item.fuelType || "-"})</label>
                    <Input
                      value={item.Initialiy_rob}
                      onChange={(e) =>
                        handleFuelChange(index, "Initialiy_rob", sanitizePositive(e.target.value))
                      }
                      placeholder="Enter ROB value"
                      type="number"
                      min={0}
                      onKeyDown={preventNegativeInput}
                    />
                  </Col>
                </Row>
              </div>
            ))}
            <Button type="dashed" onClick={handleAddFuelType} style={{ marginTop: 8 }}>
              + Add Another Fuel Type
            </Button>
          </div>

          <div className="input-box" style={{ marginTop: "15px" }}>
            <Form.Item>
              <Button type="primary" htmlType="submit" className="save_btn" loading={loader}>
                Save
              </Button>
            </Form.Item>
          </div>
        </Form>
      )}
    </div>
  );
}

export default AddStaffVoyage;
